import React from "react";
import PropTypes from "prop-types";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

const ModalBikeLastPosition = withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    defaultZoom={14}
    defaultCenter={{
      lng: props.coordinates[0],
      lat: props.coordinates[1]
    }}
  >
    <Marker
      position={{
        lng: props.coordinates[0],
        lat: props.coordinates[1]
      }}
    />
  </GoogleMap>));

ModalBikeLastPosition.propTypes = {
  coordinates: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ModalBikeLastPosition;



// WEBPACK FOOTER //
// ./src/views/pages/bikes-history/modal-bike-last-position.js